import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/signals/analyze';
import { fetchRequest as fetchLatestAnalysis } from '../../actions/signals/latestAnalysis';
import { Error } from '../../actions/error/error';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';

/* POST /signal/analyze — manually (re)run the workspace analysis.
   On success we immediately re-poll latest-analysis so the page flips
   into its "in progress" state without waiting for the next tick. */
function* process(action) {
  try {
    const { force = false } = action.payload || {};
    const response = yield call(
      axios.post,
      `${config.API_URL}/signal/analyze${force ? '?force=true' : ''}`,
      {},
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response.data.data || response.data));
    yield put(fetchLatestAnalysis({ skip_refresh: true }));
  } catch (error) {
    yield put(Error(error));
    const body = error?.response?.data?.data || error?.response?.data || {};
    yield put(fetchFailure(
      body.message || body.error || error?.message || 'Failed to start analysis',
    ));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
